export const Size = {
	XSMALL: 'xsmall',
	SMALL: 'small',
	MEDIUM: 'medium',
	LARGE: 'large',
	XLARGE: 'xlarge',
};

export type Size = (typeof Size)[keyof typeof Size];
